import {
  VideoWrapper,
  VideoIcon,
  VideoInfo,
  VideoTitle,
  VideoMeta,
  VideoProgress,
} from './styles';

export const VideoLoader = ({ filename, progress }: { filename: string, progress: number }) => {
  return (
    <VideoWrapper>
      <VideoIcon>🎬</VideoIcon>
      <VideoInfo>
        <VideoTitle>{filename || "Subiendo video..."}</VideoTitle>
        <VideoMeta>{progress || 0}%</VideoMeta>
      </VideoInfo>
      <VideoProgress>⏳</VideoProgress>
    </VideoWrapper>
  );
};